import { render, staticRenderFns } from "./GrPublicNavBarCandidates.vue?vue&type=template&id=a6b06572&scoped=true&"
import script from "./GrPublicNavBarCandidates.vue?vue&type=script&lang=ts&"
export * from "./GrPublicNavBarCandidates.vue?vue&type=script&lang=ts&"
import style0 from "./GrPublicNavBarCandidates.vue?vue&type=style&index=0&id=a6b06572&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b06572",
  null
  
)

/* custom blocks */
import block0 from "./GrPublicNavBarCandidates.json?vue&type=custom&index=0&blockType=i18n&issuerPath=D%3A%5Ca%5C1%5Cs%5Ccomponents%5Ccommon%5CGrPublicNavBarCandidates.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAppBar,VCol,VMenu,VRow,VSpacer})
